module.exports = __webpack_public_path__ + "static/media/infoJumbo2.89d224f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/msmarking/images/infoJumbo2.png
// module id = 526
// module chunks = 0